import React from 'react';

interface Props {
  resetError?: () => void;
}

const GlobalErrorFallback: React.FC<Props> = ({ resetError }) => {
  const handleReload = () => {
    if (resetError) {
      resetError();
    }
    window.location.reload();
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-blue-gray-900 text-white p-6">
      <div className="max-w-xl text-center space-y-4">
        <h1 className="text-3xl font-semibold">Что-то пошло не так</h1>
        <p className="text-base opacity-80">
          Мы уже получили информацию об ошибке и разбираемся в случившемся. Попробуйте перезагрузить
          страницу или вернитесь позже.
        </p>
        <button
          type="button"
          className="px-6 py-3 rounded-lg bg-light-blue-500 text-white font-semibold hover:bg-light-blue-600 transition"
          onClick={handleReload}
        >
          Перезагрузить страницу
        </button>
      </div>
    </div>
  );
};

export default GlobalErrorFallback;
